import React, {useEffect} from 'react';
import {NotificationContainer} from 'react-notifications';
import {Route, Switch} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import pagesSaga from 'sagas/foldersSaga';
import {Redirect} from 'react-router';
import {useInjectSaga} from 'utils/injectSaga';
import {fetchFolders} from 'actions/folderActions';
import {makeSelectInitialLoadUserDone} from 'reducers/selectors/userSelectors';
import {loadUserFromLocalStorage} from 'actions/userActions';
import {BASE_DIRECTORY} from 'config';

import LoadingIndicator from 'components/LoadingIndicator';
import NotFoundPage from 'containers/NotFoundPage/Loadable';
import Signing from 'containers/Signing/Loadable';
import ForgotPassword from 'containers/ForgotPassword/Loadable';
import ResetPassword from 'containers/ResetPassword/Loadable';
import Dashboard from 'containers/Dashboard/Loadable';
import Admin from 'containers/Admin';
import PostCategories from 'containers/Categories/Post/Loadable';
import InformationCategories from 'containers/Categories/Information/Loadable';
import CompanyCategories from 'containers/Categories/Company/Loadable';
import Readers from 'containers/Admin/Users/Readers/Loadable';
import Seller from 'containers/Admin/Users/Seller/Loadable';
import Posts from 'containers/Posts/Loadable';
import Pages from 'containers/Pages/Loadable';
import PreviewPost from 'containers/Posts/Preview/Loadable';
import TranslationPreview from 'containers/Posts/TranslationPreview/Loadable';
import Company from 'containers/Company/Loadable';
import CreateCompany from 'containers/Company/Create/Loadable';
import EditCompany from 'containers/Company/Edit/Loadable';
import PartnerPage from 'containers/Admin/Users/Loadable';
import CreatePost from 'containers/Posts/Create/Loadable';
import EditPost from 'containers/Posts/Create/LoadableEdit';
import Overview from 'containers/CompanyUser/Overview/Loadable';
import CompanyPosts from 'containers/CompanyUser/Posts/Loadable';
import PostView from 'containers/Posts/View/Loadable';
import Cloud from 'containers/CompanyUser/Cloud/Loadable';
import Analyse from 'containers/CompanyUser/Analyse/Loadable';
import Account from 'containers/CompanyUser/Account/Loadable';
import ImportPosts from 'containers/Admin/Import/Loadable';
import PartnerPreview from 'containers/Company/Preview';
import Editor from 'containers/Admin/Users/Editor/Loadable';
import Showroom from 'containers/Showroom/Loadable';
import UiTranslations from 'containers/UiTranslations';
import userSaga from 'sagas/userSaga';
import uiStateSaga from 'sagas/uiStateSaga';
import 'styles/index.scss';
import 'react-notifications/lib/notifications.css';
import competitionSaga from '../../sagas/competitionSaga';
import {fetchCompetitions} from '../../actions/competitionActions';
import JudgePage from '../Admin/Users/Judge/Loadable';
import PrivateRoute from './privateRoute';
import MigratedPortalRedirect from './MigratedPortalRedirect';

const initialLoadUserDoneSelector = makeSelectInitialLoadUserDone();

export default function App() {
  useInjectSaga({key: 'user', saga: userSaga});
  useInjectSaga({key: 'uiState', saga: uiStateSaga});
  useInjectSaga({key: 'pages', saga: pagesSaga});
  useInjectSaga({key: 'competition', saga: competitionSaga});

  const dispatch = useDispatch();
  const initialLoadUserDone = useSelector(initialLoadUserDoneSelector);

  // const userDetails = useSelector(basicUserSelector);
  useEffect(() => {
    dispatch(loadUserFromLocalStorage());
    dispatch(fetchCompetitions());
  }, []);
  useEffect(() => {
    if (initialLoadUserDone) {
      dispatch(fetchFolders());
    }
  }, [initialLoadUserDone]);

  // useEffect(() => {
  //     console.log(competition);
  //     if (  competition && competition.current) {
  //         history.push(`/posts/${competition.current._id}/architecture`);
  //     }
  //
  // }, [competition]);
  return (
    <div className="app-wrapper">
      <NotificationContainer />
      <>
        {!initialLoadUserDone ? (
          <LoadingIndicator />
        ) : (
          <Switch>
            <Route
              exact
              path={`${BASE_DIRECTORY}/logout`}
              component={Signing}
            />
            <Route exact path={`${BASE_DIRECTORY}/login`} component={Signing} />
            <Route
              exact
              path={`${BASE_DIRECTORY}/partner/login`}
              render={(props) => <MigratedPortalRedirect {...props} portal="partner" />}
            />
            <Route
              exact
              path={`${BASE_DIRECTORY}/forgot-password`}
              component={ForgotPassword}
            />
            <Route
              exact
              path="/reset-password/:token"
              component={ResetPassword}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/`}
              component={Dashboard}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/admin`}
              allow={['admin']}
              component={Admin}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/admin/:tabId`}
              allow={['admin']}
              component={Admin}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/admin/:tabId/:folderId`}
              allow={['admin']}
              component={Admin}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/ui-translations`}
              allow={['admin', 'editor']}
              component={UiTranslations}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company`}
              allow={['admin', 'reviewer', 'manager', 'editor', 'seller']}
              component={Company}
            />
            {/* <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/add`}
              component={CreateCompany}
            /> */}
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/add/:id`}
              allow={['admin', 'reviewer', 'manager', 'editor', 'seller']}
              component={CreateCompany}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/edit/:id`}
              allow={['admin', 'reviewer', 'manager', 'editor', 'seller']}
              component={EditCompany}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/:companyId/preview`}
              allow={['admin', 'reviewer', 'manager', 'editor', 'seller']}
              component={PartnerPreview}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/cloud`}
              allow={['admin', 'manager', 'editor', 'seller']}
              component={Company}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/contract`}
              allow={['admin', 'manager', 'editor', 'seller']}
              component={Company}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/cloud/:folderId`}
              allow={['admin', 'manager', 'editor', 'seller']}
              component={Company}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/profile`}
              allow={['admin', 'reviewer', 'manager', 'editor', 'seller']}
              component={Company}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/about`}
              allow={['admin', 'reviewer', 'manager', 'editor', 'seller']}
              component={Company}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/partner`}
              allow={['admin', 'manager', 'editor', 'seller']}
              component={Company}
            />
            {/* <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts`}
              component={Posts}
            /> */}
            <Route exact path={`${BASE_DIRECTORY}/posts`}>
              <Redirect to={`${BASE_DIRECTORY}/posts/architectures`} />
            </Route>
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:pageId`}
              allow={['admin', 'reviewer', 'manager', 'editor']}
              component={Posts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:pageId/filter/:pageNumber`}
              allow={['admin', 'reviewer', 'manager', 'editor']}
              component={Posts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:pageId/filter/:pageNumber/:status`}
              allow={['admin', 'reviewer', 'manager', 'editor']}
              component={Posts}
            />
            <Route exact path={`${BASE_DIRECTORY}/information-posts`}>
              <Redirect to={`${BASE_DIRECTORY}/information-posts/catalogues`} />
            </Route>
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/information-posts/:pageId`}
              component={Posts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:pageId/add`}
              component={CreatePost}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:pageId/add/:postId`}
              component={EditPost}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:pageId/translation-preview/:sourcePostId/:language`}
              component={TranslationPreview}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:postId/preview`}
              component={PreviewPost}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:competitionId/:pageId`}
              component={Posts}
            />
            <PrivateRoute
              exact
              path="/page"
              allow={['admin']}
              component={Pages}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/categories/posts`}
              allow={['admin', 'manager', 'editor']}
              component={PostCategories}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/categories/information`}
              allow={['admin', 'manager', 'editor']}
              component={InformationCategories}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/categories/company`}
              allow={['admin', 'manager', 'editor']}
              component={CompanyCategories}
            />
            <Route
              exact
              path={['/fav-posts', '/fav-information-posts', '/fav-company']}
              render={(props) => <MigratedPortalRedirect {...props} portal="reader" />}
            />
            <Route
              exact
              path={['/overview', '/company-posts', '/company-information', '/cloud', '/account', '/analyse', '/analysis']}
              render={(props) => <MigratedPortalRedirect {...props} portal="partner" />}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/overview/:companyId`}
              component={Overview}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company-posts/:companyId`}
              component={CompanyPosts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/post/view/:postId`}
              component={PostView}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company-information/:companyId`}
              component={CompanyPosts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/cloud/:companyId`}
              component={Cloud}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/account/:companyId`}
              component={Account}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/analyse/:companyId`}
              component={Analyse}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/analysis/:companyId`}
              component={Analyse}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/partners`}
              allow={['admin', 'manager', 'editor', 'seller']}
              component={PartnerPage}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/readers`}
              allow={['admin']}
              component={Readers}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/seller`}
              allow={['admin']}
              component={Seller}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/import-posts`}
              component={ImportPosts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/judge`}
              component={JudgePage}
            />{' '}
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/judge/:tab`}
              component={JudgePage}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/editors`}
              allow={['admin']}
              component={Editor}
            />
            {/* <Route exact path={judgePath}> */}
            {/*  <JudgePage /> */}
            {/* </Route> */}
            {/* <Route path={`${judgePath}/:tab`}> */}
            {/*  <JudgePage /> */}
            {/* </Route> */}
            {/* <Route path={`${judgePath}/time`}> */}
            {/*  <Time /> */}
            {/* </Route> */}
            {/* <Route path={`${judgePath}/award`}> */}
            {/*  <Award /> */}
            {/* </Route> */}
            {/* <Route path={`${judgePath}/candidate`}> */}
            {/*  <Candidate /> */}
            {/* </Route> */}
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/events`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/hosts`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/members`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/packages`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/rooms`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/viewers`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/requests`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/approvals`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/add`} allow={['admin', 'manager', 'editor']} component={() => <Redirect to="/showroom/events" />} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/edit/:id`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/:id`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/:id/viewers`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/:id/requests`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/:id/approvals`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/:id/chat`} allow={['admin', 'manager', 'editor']} component={Showroom} />
            <PrivateRoute exact path={`${BASE_DIRECTORY}/showroom/:id/grants/send`} allow={['admin', 'manager', 'editor']} component={({match}) => <Redirect to={`/showroom/${match.params.id}`} />} />
            <Route component={NotFoundPage} />
          </Switch>
        )}
      </>
    </div>
  );
}
